// import './text.scss';

function init() {
    console.log("icons.js initialized");
    // doesn't do anything
}
export default init;